import React from 'react';
import styles from '../../styles/GestionInteresadosStyles/GestionInteresados.module.css';

function StatusBadge({ status }) {
  const getStatusClass = (status) => {
    switch (status) {
      case 'ACEPTADO':
        return styles.statusAccepted;
      case 'EN_PROCESO':
      case 'EN PROCESO':
        return styles.statusInProcess;
      case 'NUEVO':
        return styles.statusNew;
      case 'RECHAZADO':
        return styles.statusRejected;
      case 'SEGUIMIENTO':
        return styles.statusFollowUp || styles.statusInProcess;
      case 'EN_ESPERA':
        return styles.statusOnHold || styles.statusDefault;
      case 'PERDIO_INTERES':
        return styles.statusLostInterest || styles.statusRejected;
      case 'MATRICULADO':
        return styles.statusEnrolled || styles.statusAccepted;
      case 'INSCRITO':
        return styles.statusEnrolled || styles.statusAccepted;
      default:
        return styles.statusDefault;
    }
  };

  const displayLabel = {
    'NUEVO': 'NUEVO',
    'SEGUIMIENTO': 'SEGUIMIENTO',
    'EN_ESPERA': 'EN ESPERA',
    'EN_PROCESO': 'EN PROCESO',
    'EN PROCESO': 'EN PROCESO',
    'ACEPTADO': 'ACEPTADO',
    'RECHAZADO': 'RECHAZADO',
    'PERDIO_INTERES': 'PERDIÓ INTERÉS',
    'MATRICULADO': 'MATRICULADO',
    'INSCRITO': 'INSCRITO',
  };

  return (
    <span className={`${styles.statusBadge} ${getStatusClass(status)}`}>
      {displayLabel[status] || status}
    </span>
  );
}

export default StatusBadge;
